module.exports = __webpack_public_path__ + "img/11_116.bd72dcad.png";